import { UseCustomAxios } from "../../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../../util/Utils";

export function UseHomeCategory() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      title: isEmpty(state.title),
    };

    setter(errorState);

    if (errorState.title) {
      enqueueSnackbar("لطفا اطلاعات دسته بندی را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  function validateItem(state, setter) {
    let errorState = {
      title: isEmpty(state.title),
      url: isEmpty(state.url),
    };

    setter(errorState);

    if (errorState.title || errorState.url) {
      enqueueSnackbar("لطفا اطلاعات آیتم را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const GetHomeCategories = (categoryID, callback) => {
    MyAxios.get(`Admin_HomeCategory`, {
      headers: {
        AID: categoryID,
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetCategoryByID = (categoryID, callback) => {
    MyAxios.get(`Admin_HomeCategory/${categoryID}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const addCategoryBox = (state, Image, Image2, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (Image) {
      data.append("Image", Image);
    }
    if (Image2) {
      data.append("Image2", Image2);
    }
    MyAxios.post(`Admin_HomeCategory`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("دسته بندی با موفقیت افزوده شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const updateCategoryBox = (state, Image, Image2, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (Image) {
      data.append("Image", Image);
    }
    if (Image2) {
      data.append("Image2", Image2);
    }
    MyAxios.put(`Admin_HomeCategory`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("دسته بندی با موفقیت ویرایش شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deleteCategoryBox = (CategoryID, callback) => {
    const data = new FormData();
    data.append("CategoryID", CategoryID);
    MyAxios.delete(`Admin_HomeCategory`, { data: data }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("دسته بندی با موفقیت حذف شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };
  const addCategoryItem = (state, Image, icon, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (Image) {
      data.append("Image", Image);
    }
    if (icon) {
      data.append("icon", icon);
    }
    MyAxios.post(`Admin_HomeCategory/Item`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("آیتم با موفقیت افزوده شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const updateCategoryItem = (state, Image, icon, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (Image) {
      data.append("Image", Image);
    }
    if (icon) {
      data.append("icon", icon);
    }
    MyAxios.put(`Admin_HomeCategory/Item`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("آیتم با موفقیت ویرایش شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deleteCategoryItem = (CategoryItemID, callback) => {
    const data = new FormData();
    data.append("CategoryItemID", CategoryItemID);
    MyAxios.delete(`Admin_HomeCategory/Item`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("آیتم با موفقیت حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  return {
    validate,
    validateItem,
    GetHomeCategories,
    GetCategoryByID,
    addCategoryBox,
    updateCategoryBox,
    deleteCategoryBox,
    addCategoryItem,
    updateCategoryItem,
    deleteCategoryItem,
  };
}
